export { default } from './ErrorInterceptor';



// WEBPACK FOOTER //
// ./src/core/ErrorInterceptor/index.ts